import { Modal } from 'ant-design-vue';

import i18n from '@/i18n';
import { install } from '@/services/extension';
import { getBrowserName } from '@/services/browser';

function showDialog(ctr, options = {}) {
  Modal.destroyAll();
  return ctr({
    centered: true,
    autoFocusButton: 'ok',
    closable: true,
    maskClosable: true,
    ...options,
  });
}

export const showSignUpFailedDialog = (message) =>
  showDialog(Modal.error, {
    title: i18n.t('signup.failure'),
    content: i18n.t(message) || i18n.t('error'),
  });

export const showInstallExtensionDialog = () => {
  showDialog(Modal.info, {
    title: i18n.t('extension.not.installed.title'),
    content: i18n.t('extension.not.installed', { browser: getBrowserName() }),
    okText: i18n.t('install.extension'),
    onOk: () => install(),
  });
};

export const showExtensionInstalledDialog = () =>
  showDialog(Modal.info, {
    title: i18n.t('extension.installed.title'),
    content: i18n.t('extension.installed'),
  });
